import React, { useLayoutEffect, useRef, useState } from 'react';
import useResizeObserver from '@react-hook/resize-observer';
import range from 'lodash/range';
import { useTranslation } from 'common/i18n/hooks';
import styles from './_chart-header.module.styl';
type ExperimentPageSummaryMetricsCategoryChartHeaderProps = {
  absMax: number;
};

// https://github.com/jaredLunde/react-hook/tree/master/packages/resize-observer#readme
const useWidth = (target: any) => {
  const [width, setWidth] = useState(0);
  useLayoutEffect(() => {
    setWidth(target.current.clientWidth);
  }, [target]);
  useResizeObserver(target, entry => setWidth(entry.contentRect.width));
  return width;
};
export function ExperimentPageSummaryMetricsCategoryChartHeader(props: ExperimentPageSummaryMetricsCategoryChartHeaderProps) {
  const target = useRef<HTMLDivElement>(null);
  const width = useWidth(target);
  const tickCount = width < 300 ? 3 : 5;
  const diff = 2 * props.absMax;
  const start = -props.absMax * (tickCount - 1) / tickCount;
  const end = props.absMax * (tickCount - 1) / tickCount;
  const step = (end - start) / (tickCount - 1);
  const ticks = range(0, tickCount).map(i => start + i * step);
  const i18n = useTranslation();
  const percentFormatter = new Intl.NumberFormat(i18n.language, {
    style: "percent",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
  return <div ref={target} className={styles.wrapper} data-sentry-component="ExperimentPageSummaryMetricsCategoryChartHeader" data-sentry-source-file="_chart-header.tsx">
      {ticks.map((tick, i) => <div key={i} className={styles.tick} style={{
      left: "".concat((tick + props.absMax) / diff * 100, "%")
    }}>
          {percentFormatter.format(tick)}
        </div>)}
    </div>;
}